"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var atoms_1 = require("../../../styles/atoms");
function Badges(props) {
    var _a = props.badges, discount = _a.discount, novelty = _a.novelty, quality = _a.quality, popularity = _a.popularity, certified = _a.certified;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(atoms_1.Div, { visible: discount !== 0 },
            react_1.default.createElement(DiscountBadge, null, "sale")),
        react_1.default.createElement(atoms_1.Div, { visible: novelty },
            react_1.default.createElement(NewBadge, null, "new")),
        react_1.default.createElement(atoms_1.Div, { visible: popularity !== 0 },
            react_1.default.createElement(PopularityBadge, null, "\u0445\u0438\u0442")),
        react_1.default.createElement(atoms_1.Div, { visible: quality },
            react_1.default.createElement(QualityBadge, null, "quality"))));
}
exports.default = Badges;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  z-index: 1;\n"], ["\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  z-index: 1;\n"])));
var Badge = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: white;\n  padding: 6px 0px;\n  width: 50px;\n  text-align: center;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 12px;\n  margin-bottom: 4px;\n"], ["\n  color: white;\n  padding: 6px 0px;\n  width: 50px;\n  text-align: center;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 12px;\n  margin-bottom: 4px;\n"])));
var DiscountBadge = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: #f44a36;\n  ", "\n"], ["\n  background: #f44a36;\n  ", "\n"])), Badge);
var NewBadge = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #2f96b4;\n  ", "\n"], ["\n  background: #2f96b4;\n  ", "\n"])), Badge);
var PopularityBadge = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: #f3c44f;\n  ", "\n"], ["\n  background: #f3c44f;\n  ", "\n"])), Badge);
var QualityBadge = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: #3cb868;\n  ", "\n"], ["\n  background: #3cb868;\n  ", "\n"])), Badge);
var CertifiedMaskBadge = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background: red;\n  ", "\n"], ["\n  background: red;\n  ", "\n"])), Badge);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
